import { render, staticRenderFns } from "./Customerservice.vue?vue&type=template&id=6a1e48b3&scoped=true"
import script from "./Customerservice.vue?vue&type=script&lang=js"
export * from "./Customerservice.vue?vue&type=script&lang=js"
import style0 from "./Customerservice.vue?vue&type=style&index=0&id=6a1e48b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1e48b3",
  null
  
)

export default component.exports